/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosConfig";
import { cleanRut, validateRut, formatRut } from '../../utils/rut';
import Select from 'react-select';


const usoTutorPacienteOptions = [
    { value: 0, label: 'No' },
    { value: 1, label: 'Si' }
];

const usoFacturacionPacienteOptions = [
    { value: 0, label: 'No' },
    { value: 1, label: 'Si' }
];

const turnosPacienteOptions = [
    { value: 1, label: 'Día' },
    { value: 2, label: 'Noche' },
    { value: 3, label: '24 Horas' }
];

const FormPacienteInicial = () => {

    const [datosDias, setdatosDias] = useState([]);
    const [cantidadDias, setCantidadDias] = useState(0)

    const daysOfWeek = [
        { value: 1, label: "Lunes" },
        { value: 2, label: "Martes" },
        { value: 3, label: "Miércoles" },
        { value: 4, label: "Jueves" },
        { value: 5, label: "Viernes" },
        { value: 6, label: "Sábado" },
        { value: 7, label: "Domingo" },
    ];

    const daysMap = [
        { value: 'Mon', label: 'Lunes' },
        { value: 'Tue', label: 'Martes' },
        { value: 'Wed', label: 'Miércoles' },
        { value: 'Thu', label: 'Jueves' },
        { value: 'Fri', label: 'Viernes' },
        { value: 'Sat', label: 'Sábado' },
        { value: 'Sun', label: 'Domingo' }
    ];

    const [diasOrdenadosUI, setDiasOrdenadosUI] = useState(daysMap.map(d => d.value)); // Mon..Sun

    const ordenarDiasDesdeFecha = (fecha) => {
        const diasOrdenados = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']; // Tu orden deseado

        const [year, month, day] = fecha.split("-");
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        let diaSemana = date.getDay(); // 0 = domingo, 1 = lunes, ..., 6 = sábado

        // Convertir 0 (domingo) a 7
        if (diaSemana === 0) diaSemana = 7;

        // Como nuestro arreglo parte en lunes (índice 0 = lunes), restamos 1
        const idxInicio = diaSemana;

        return [
            ...diasOrdenados.slice(idxInicio),
            ...diasOrdenados.slice(0, idxInicio)
        ];
    };
    const toggleDay = (day) => {
        setdatosDias((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
    };

    const [datosPaciente, setDatosPaciente] = useState({
        rut: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        fechaNacimiento: "",
        fecha_ingreso_sk: "",
        direccion: "",
        como_llegar: "",
        comuna: "",
        diagnostico: "",
        tipoTurno: "",
        horaInicio: "",
        horaFin: "",
        utilizaDatosFacturacion: 1,
        sector: "",
        viveFueraSantiago: false,
        correosNotificacion: ""
    });

    const [datosTutorPago, setDatosTutorPago] = useState({
        rut: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        relacion: "",
        correo: "",
        celular: "",
        fechaInicioServicio: "",
        duracionServicio: "",
        utilizarTutorPaciente: 0
    });

    const [datosTutorPaciente, setDatosTutorPaciente] = useState({
        rut: "",
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        relacion: "",
        correo: "",
        celular: "",
        fechaInicioServicio: "",
        duracionServicio: "",
    });

    const [datosValoresServicios, setDatosValoresServicios] = useState({
        valorTurnoPaciente: 0,
        valorTurnoBasePaciente: 0,
        valorTurnoAlternativoPaciente: 0,
        tipoValorAlternativoPaciente: 0,
        valorColacionPaciente: 0,
        valorLocomocionPaciente: 0,
        valorOtroPaciente: 0,
        valorTurnoAuxiliar: 0,
        valorTurnoBaseAuxiliar: 0,
        valorColacionAuxiliar: 0,
        valorLocomocionAuxiliar: 0,
        valorOtroAuxiliar: 0,
        recordatorio: ""
    });

    const [datosFacturacion, setDatosFacturacion] = useState({
        razonSocial: "",
        rut: "",
        giro: "",
        direccion: "",
        comuna: ""
    });

    const resetForm = () => {
        setdatosDias([]);
        setCantidadDias(0);
        setPatternName("");
        setPatternType("fixed");
        setFixedPeriod("day");
        setPatternRows([]);
        setServiceDays(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);
        setPatternStartTime("");
        setPatternEndTime("");
        setStartDate("");
        setTemplateSelected(null);

        setDatosPaciente({
            rut: "",
            nombres: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            fechaNacimiento: "",
            fecha_ingreso_sk: "",
            direccion: "",
            como_llegar: "",
            comuna: "",
            diagnostico: "",
            tipoTurno: "",
            horaInicio: "",
            horaFin: "",
            utilizaDatosFacturacion: 1,
            sector: "",
            viveFueraSantiago: false,
            correosNotificacion: ""
        });

        setDatosTutorPago({
            rut: "",
            nombres: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            relacion: "",
            correo: "",
            celular: "",
            fechaInicioServicio: "",
            duracionServicio: "",
            utilizarTutorPaciente: 0
        });

        setDatosTutorPaciente({
            rut: "",
            nombres: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            relacion: "",
            correo: "",
            celular: "",
            fechaInicioServicio: "",
            duracionServicio: "",
        });

        setDatosValoresServicios({
            valorTurnoPaciente: 0,
            valorTurnoBasePaciente: 0,
            valorTurnoAlternativoPaciente: 0,
            tipoValorAlternativoPaciente: 0,
            valorColacionPaciente: 0,
            valorLocomocionPaciente: 0,
            valorOtroPaciente: 0,
            valorTurnoAuxiliar: 0,
            valorTurnoBaseAuxiliar: 0,
            valorColacionAuxiliar: 0,
            valorLocomocionAuxiliar: 0,
            valorOtroAuxiliar: 0,
            recordatorio: ""
        });

        setDatosFacturacion({
            razonSocial: "",
            rut: "",
            giro: "",
            direccion: "",
            comuna: ""
        });
    };


    const [comunas, setComunas] = useState([]);

    const [startDate, setStartDate] = useState("");
    const [serviceDays, setServiceDays] = useState(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']);            // ['Mon','Tue',...]
    const [skipInfo, setSkipInfo] = useState("Selecciona fecha y días para ver saltos.");
    const [patternName, setPatternName] = useState("");
    const [patternType, setPatternType] = useState("fixed");        // 'fixed' | 'rotative'
    const [fixedPeriod, setFixedPeriod] = useState("day");         // 'day' | 'night' | 'full' | 'off'
    const [patternRows, setPatternRows] = useState([]);             // [{ period, days }]
    const [patronesTemplates, setPatronesTemplates] = useState([]);
    const [templateSelected, setTemplateSelected] = useState(null);


    // Actualiza texto de skipInfo
    const updateSkipInfo = () => {
        if (!startDate || serviceDays.length === 0) {
            setSkipInfo('Selecciona fecha y días para ver saltos.');
            return;
        }
        const [sYear, sMonth, sDay] = startDate.split("-");
        const s = new Date(parseInt(sYear), parseInt(sMonth) - 1, parseInt(sDay));
        for (let i = 0; i < 7; i++) {
            const d = new Date(s);
            d.setDate(s.getDate() + i);
            const wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()];
            if (serviceDays.includes(wd)) {
                setSkipInfo(i === 0 ? 'Inicia ese día.' : `Primer turno en ${i} día(s).`);
                return;
            }
        }
        setSkipInfo('No hay día marcado en la semana.');
    };


    useEffect(() => {
        setStartDate(datosTutorPago.fechaInicioServicio);
    }, [datosTutorPago.fechaInicioServicio]);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const response = await axiosInstance.get("/patrones-rotacion/listar");
                if (!response.data.error) {
                    setPatronesTemplates((response.data.data || []).map((p) => ({
                        value: p.id,
                        label: `${p.titulo} (${p.cantidad_auxiliares || 1} Auxiliares)`,
                        data: p
                    })));
                }
            } catch (error) {
                console.error("Error loading templates:", error);
            }
        };

        fetchTemplates();
    }, []);

    useEffect(() => {
        updateSkipInfo();

        if (startDate) {
            const nuevoOrden = ordenarDiasDesdeFecha(startDate);
            setDiasOrdenadosUI(nuevoOrden);
        }
    }, [startDate, serviceDays]);
    // Manejadores para días de servicio
    const toggleServiceDay = (day) => {
        setServiceDays(prev =>
            prev.includes(day)
                ? prev.filter(d => d !== day)
                : [...prev, day]
        );
    };

    // Manejadores de patrón rotativo
    const addPatternRow = () => {
        setPatternRows(prev => [...prev, { period: 'day', days: '', start: '', end: '', status: 'libre', dailyPeriods: [] }]);
    };
    const removePatternRow = (index) => {
        setPatternRows(prev => prev.filter((_, i) => i !== index));
    };
    const handlePatternRowChange = (index, field, value) => {
        setPatternRows(prev => prev.map((row, i) => {
            if (i === index) {
                const updatedRow = { ...row, [field]: value };
                if (field === 'days' && updatedRow.period === 'mixto') {
                    const numDays = parseInt(value) || 0;
                    updatedRow.dailyPeriods = Array.from({ length: numDays }, (_, k) => row.dailyPeriods?.[k] || 'full');
                } else if (field === 'period' && value === 'mixto') {
                    const numDays = parseInt(row.days) || 0;
                    updatedRow.dailyPeriods = Array.from({ length: numDays }, (_, k) => row.dailyPeriods?.[k] || 'full');
                }
                return updatedRow;
            }
            return row;
        }));
    };

    const handleDailyPeriodChange = (rowIndex, dayIndex, value) => {
        setPatternRows(prev => prev.map((row, i) => {
            if (i === rowIndex) {
                const newDailyPeriods = [...(row.dailyPeriods || [])];
                newDailyPeriods[dayIndex] = value;
                return { ...row, dailyPeriods: newDailyPeriods };
            }
            return row;
        }));
    };

    const [patternStartTime, setPatternStartTime] = useState("");
    const [patternEndTime, setPatternEndTime] = useState("");

    const applyPatternTemplate = () => {
        if (!templateSelected?.data) {
            gdAlertify.notiError("Debe seleccionar una plantilla.");
            return;
        }

        try {
            const template = templateSelected.data;
            const config = typeof template.configuracion === "string"
                ? JSON.parse(template.configuracion)
                : (template.configuracion || {});

            setPatternType(template.tipo || "fixed");
            setPatternStartTime(config.horaInicio || "");
            setPatternEndTime(config.horaFin || "");
            setServiceDays(Array.isArray(config.serviceDays) ? config.serviceDays : []);

            if (template.tipo === "rotative") {
                setPatternRows(Array.isArray(config.phases) ? config.phases : []);
            } else {
                setFixedPeriod(config.period || "day");
                setPatternRows([]);
            }

            gdAlertify.notiSuccess(`Plantilla "${template.titulo}" aplicada`);
        } catch (error) {
            console.error("Error applying template:", error);
            gdAlertify.notiError("No se pudo aplicar la plantilla seleccionada.");
        }
    };



    // Cargar las comunas desde el backend
    useEffect(() => {
        const obtenerComunas = async () => {
            gdAlertify.showLoader()
            try {
                const response = await axiosInstance.get("/params/comunas"); // Cambia la URL por la correcta
                if (response.data && !response.data.error) {
                    setComunas(response.data.comunas.map(comuna => ({
                        value: comuna.id,
                        label: comuna.nombre
                    })));
                } else {
                    gdAlertify.notiError("No se pudieron cargar las comunas.");
                }
                gdAlertify.hideLoader()
            } catch (error) {
                gdAlertify.hideLoader()
                console.error(error);
                gdAlertify.notiError("Ocurrió un error al cargar las comunas.");
            }
        };

        obtenerComunas();
    }, []);

    const [turnos, setTurnos] = useState([]); // Estado para turnos

    // Cargar los turnos desde el backend
    useEffect(() => {
        const obtenerTurnos = async () => {
            try {
                const response = await axiosInstance.get("/params/turnos"); // Cambiar al endpoint correcto
                if (response.data && !response.data.error) {
                    setTurnos(response.data.turnos.map(turno => ({
                        value: turno.id,
                        label: turno.nombre,
                    })));
                } else {
                    gdAlertify.notiError("No se pudieron cargar los turnos.");
                }
            } catch (error) {
                console.error(error);
                gdAlertify.notiError("Ocurrió un error al cargar los turnos.");
            }
        };

        obtenerTurnos();
    }, []);


    const handleDatosValoresServicios = (e) => {
        const { name, value } = e.target;
        setDatosValoresServicios({
            ...datosValoresServicios,
            [name]: value,
        });
    };

    const handleChangeTutorPago = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosTutorPago({ ...datosTutorPago, [name]: formatRut(cleanedRut) });
        } else {
            setDatosTutorPago({ ...datosTutorPago, [name]: value });
        }
    };

    const handleChangeTutorDoble = (selectedOption) => {
        if (selectedOption != null) {
            setDatosTutorPago({ ...datosTutorPago, utilizarTutorPaciente: selectedOption ? selectedOption.value : "" });
        }
    };

    const handleChangeDatosFacturacionPaciente = (selectedOption) => {
        if (selectedOption != null) {
            setDatosPaciente({ ...datosPaciente, utilizaDatosFacturacion: selectedOption ? selectedOption.value : "" });
        }
    };

    const handleChangeTutorPaciente = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosTutorPaciente({ ...datosTutorPaciente, [name]: formatRut(cleanedRut) });
        } else {
            setDatosTutorPaciente({ ...datosTutorPaciente, [name]: value });
        }
    };

    // Maneja el cambio en los campos del paciente
    const handleChangePaciente = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosPaciente({ ...datosPaciente, [name]: formatRut(cleanedRut) });
        } else {
            setDatosPaciente({ ...datosPaciente, [name]: value });
        }
    };

    const handleComunaChange = (selectedOption) => {
        setDatosPaciente({ ...datosPaciente, comuna: selectedOption ? selectedOption.value : "" });
    };

    const handleComunaFacturacionChange = (selectedOption) => {
        setDatosFacturacion({ ...datosFacturacion, comuna: selectedOption ? selectedOption.value : "" });
    };

    const handleTurnoChange = (selectedOption) => {
        setDatosPaciente({ ...datosPaciente, tipoTurno: selectedOption ? selectedOption.value : "" });
        if (selectedOption?.value !== 7) {
            setCantidadDias(0);
        }
    };

    const handleChangeDatosFacturacion = (e) => {
        const { name, value } = e.target;
        if (name === "rut") {
            const cleanedRut = cleanRut(value);
            setDatosFacturacion({ ...datosFacturacion, [name]: formatRut(cleanedRut) });
        } else {
            setDatosFacturacion({ ...datosFacturacion, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (datosTutorPago.rut && !validateRut(cleanRut(datosTutorPago.rut))) {
            gdAlertify.notiError("El RUT del tutor es inválido.");
            return false;
        }

        if (!validateRut(cleanRut(datosPaciente.rut))) {
            gdAlertify.notiError("El RUT del paciente es inválido.");
            return false;
        }

        if (serviceDays.length == 0) {
            gdAlertify.notiError("Falta seleccionar dias del turno.");
            return false;
        }

        // if (datosPaciente.tipoTurno === 7 && cantidadDias <= 0) {
        //     gdAlertify.notiError("Debe ingresar una cantidad de días válida.");
        //     return false;
        // }

        if (datosPaciente.utilizaDatosFacturacion == 1) {
            setDatosFacturacion({
                razonSocial: "",
                rut: datosPaciente.rut,
                giro: "",
                direccion: datosPaciente.direccion,
                comuna: datosPaciente.comuna,
                dias: datosDias
            });
        }
        let fechaInicio = datosTutorPago.fechaInicioServicio;
        let turnos = {
            fechaInicio,
            horaInicio: patternStartTime,
            horaFin: patternEndTime,
            serviceDays,             // e.g. ['Mon','Wed','Fri']
            pattern: {
                name: patternName,
                type: patternType,      // 'fixed' o 'rotative'
                ...(patternType === 'fixed'
                    ? { period: fixedPeriod }            // sólo día, noche, full, off
                    : { phases: patternRows })           // array de { period, days }
            }
        }
        if (turnos.pattern.type === 'fixed') {
            if (!turnos.pattern.period) {
                gdAlertify.notiError("Debes seleccionar un período fijo.");
                return false;
            }
        } else if (turnos.pattern.type === 'rotative') {
            if (!Array.isArray(turnos.pattern.phases) || turnos.pattern.phases.length === 0) {
                gdAlertify.notiError("Agrega al menos una fase de rotación.");
                return false;
            }
        } else {
            gdAlertify.notiError("Tipo de patrón inválido.");
            return false;
        }

        gdAlertify.confirm({
            title: 'Registrar paciente inicial',
            message: '¿Está seguro de registrar paciente inicial?',
            onConfirm: async () => {
                try {
                    gdAlertify.showLoader()
                    const response = await axiosInstance.post("/paciente/crear", {
                        datosPaciente,
                        datosTutorPago,
                        datosTutorPaciente,
                        datosValoresServicios,
                        datosFacturacion,
                        datosDias,
                        cantidadDias: datosPaciente.tipoTurno === 7 ? cantidadDias : null,
                        turnos
                    });

                    if (!response.data.error) {
                        gdAlertify.alertSuccess(response.data.message);
                        resetForm();
                    } else {
                        gdAlertify.alertError(response.data.message);
                    }
                    gdAlertify.hideLoader()
                } catch (error) {
                    gdAlertify.hideLoader()
                    console.error(error);
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    return (
        <div className="container mt-5">
            <div className="card shadow">
                <div className="card-body">

                    <legend className="w-auto">Registro Paciente Inicial</legend>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {/* Datos del Paciente */}
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Datos Paciente</legend>
                                    <div className="row">
                                        {[
                                            { name: "rut", label: "RUT" },
                                            { name: "nombres", label: "Nombres" },
                                            { name: "apellidoPaterno", label: "Apellido Paterno" },
                                            { name: "apellidoMaterno", label: "Apellido Materno" },
                                            { name: "fechaNacimiento", label: "Fecha de Nacimiento", type: "date" },
                                            { name: "fecha_ingreso_sk", label: "Fecha de Ingreso SK", type: "date" },
                                            { name: "diagnostico", label: "Diagnóstico o Patología" },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-6" key={field.name}>
                                                <label className="form-label">{field.label}</label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosPaciente[field.name]}
                                                    onChange={handleChangePaciente}
                                                    required
                                                />
                                            </div>
                                        ))}
                                        {[
                                            { name: "direccion", label: "Dirección" },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-6" key={field.name}>
                                                <label className="form-label">{field.label}</label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosPaciente[field.name]}
                                                    onChange={handleChangePaciente}
                                                    required
                                                />
                                            </div>
                                        ))}
                                        {/* Como llegar */}
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Cómo llegar (Indicaciones)</label>
                                            <textarea
                                                className="form-control"
                                                name="como_llegar"
                                                rows="2"
                                                value={datosPaciente.como_llegar}
                                                onChange={handleChangePaciente}
                                                placeholder="Ej: Portón verde, llegar a paradero 4, etc."
                                            ></textarea>
                                        </div>
                                        {/* Comuna */}
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Comuna</label>
                                            <Select
                                                options={comunas}
                                                value={comunas.find(option => option.label === datosPaciente.comuna)}
                                                onChange={handleComunaChange}
                                                placeholder="Seleccione una comuna"
                                                isClearable
                                            />
                                        </div>
                                        {[
                                            { name: "sector", label: "Sector" },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-6" key={field.name}>
                                                <label className="form-label">{field.label}</label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosPaciente[field.name]}
                                                    onChange={handleChangePaciente}
                                                    required
                                                />
                                            </div>
                                        ))}

                                        <div className="mb-3 col-md-6">
                                            <div className="form-check form-switch pt-4">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="viveFueraSantiago"
                                                    name="viveFueraSantiago"
                                                    checked={datosPaciente.viveFueraSantiago}
                                                    onChange={(e) => setDatosPaciente({ ...datosPaciente, viveFueraSantiago: e.target.checked })}
                                                />
                                                <label className="form-check-label" htmlFor="viveFueraSantiago">
                                                    Vive fuera de Santiago
                                                </label>
                                            </div>
                                        </div>
                                        <div className="mb-3 col-md-6">
                                            <label className="form-label">Correos de notificación (separados por coma)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="correosNotificacion"
                                                value={datosPaciente.correosNotificacion}
                                                onChange={handleChangePaciente}
                                                placeholder="ejemplo1@mail.com, ejemplo2@mail.com"
                                            />
                                        </div>

                                    </div>
                                </fieldset>
                            </div>
                            {/* Datos del Tutor */}
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Datos Tutor Pago</legend>
                                    <div className="row">
                                        {[
                                            { name: "nombres", label: "Nombres", required: true },
                                            { name: "apellidoPaterno", label: "Apellido Paterno", required: true },
                                            { name: "apellidoMaterno", label: "Apellido Materno", required: true },
                                            { name: "relacion", label: "Relación o Parentesco con Paciente", required: true },
                                            { name: "correo", label: "Correo Electrónico", type: "email", required: true },
                                            { name: "celular", label: "Celular de Contacto", type: "tel", required: true },
                                        ].map((field) => (
                                            <div className="mb-3 col-md-6" key={field.name}>
                                                <label className="form-label">{field.label}</label>
                                                <input
                                                    type={field.type || "text"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosTutorPago[field.name]}
                                                    onChange={handleChangeTutorPago}
                                                    {...(field.required && { required: true })}
                                                />
                                            </div>
                                        ))}
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Tiene otro tutor</label>
                                            <Select
                                                options={usoTutorPacienteOptions}
                                                value={usoTutorPacienteOptions.find(option => option.value === datosTutorPago.utilizarTutorPaciente)}
                                                onChange={handleChangeTutorDoble}
                                                placeholder="Seleccione"
                                                isClearable
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Utilizar datos para facturacion</label>
                                            <Select
                                                options={usoFacturacionPacienteOptions}
                                                value={usoFacturacionPacienteOptions.find(option => option.value === datosPaciente.utilizaDatosFacturacion)}
                                                onChange={handleChangeDatosFacturacionPaciente}
                                                placeholder="Seleccione"
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            {/* Datos del TutorPaciente */}
                            {datosTutorPago["utilizarTutorPaciente"] === 1 && (
                                <div className="col-md-12">
                                    <fieldset className="border p-3 mb-3">
                                        <legend className="w-auto">Datos Tutor Salud</legend>
                                        <div className="row">
                                            {[
                                                { name: "nombres", label: "Nombres", required: true },
                                                { name: "apellidoPaterno", label: "Apellido Paterno", required: true },
                                                { name: "apellidoMaterno", label: "Apellido Materno", required: true },
                                                { name: "relacion", label: "Relación o Parentesco con Paciente", required: true },
                                                { name: "correo", label: "Correo Electrónico", type: "email", required: true },
                                                { name: "celular", label: "Celular de Contacto", type: "tel", required: true },
                                            ].map((field) => (
                                                <div className="mb-3 col-md-6" key={field.name}>
                                                    <label className="form-label">{field.label}</label>
                                                    <input
                                                        type={field.type || "text"}
                                                        className="form-control"
                                                        name={field.name}
                                                        value={datosTutorPaciente[field.name]}
                                                        onChange={handleChangeTutorPaciente}
                                                        {...(field.required && { required: true })}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </fieldset>
                                </div>
                            )}
                            {/* Datos de facturacion */}
                            {datosPaciente["utilizaDatosFacturacion"] === 0 && (
                                <div className="col-md-12">
                                    <fieldset className="border p-3 mb-3">
                                        <legend className="w-auto">Datos Facturacion</legend>
                                        <div className="row">
                                            {[
                                                { name: "razonSocial", label: "Razón social", required: false },
                                                { name: "rut", label: "Rut", required: true },
                                                { name: "giro", label: "Giro", required: true },
                                                { name: "direccion", label: "Direccion", required: true },
                                            ].map((field) => (
                                                <div className="mb-3 col-md-4" key={field.name}>
                                                    <label className="form-label">{field.label}</label>
                                                    <input
                                                        type={field.type || "text"}
                                                        className="form-control"
                                                        name={field.name}
                                                        value={datosFacturacion[field.name]}
                                                        onChange={handleChangeDatosFacturacion}
                                                        {...(field.required && { required: true })}
                                                    />
                                                </div>
                                            ))}
                                            {/* Comuna */}
                                            <div className="mb-3 col-md-4">
                                                <label className="form-label">Comuna</label>
                                                <Select
                                                    options={comunas}
                                                    value={comunas.find(option => option.label === datosFacturacion.comuna)}
                                                    onChange={handleComunaFacturacionChange}
                                                    placeholder="Seleccione una comuna"
                                                    isClearable
                                                />
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            )}

                            {/* Datos de turnos */}
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <div className="row align-items-end mb-3">
                                        <div className="col-md-8">
                                            <label className="form-label">Patrones-Rotacion (Template)</label>
                                            <Select
                                                options={patronesTemplates}
                                                placeholder="Seleccionar plantilla..."
                                                isClearable
                                                value={templateSelected}
                                                onChange={setTemplateSelected}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary w-100"
                                                onClick={applyPatternTemplate}
                                                disabled={!templateSelected}
                                            >
                                                Aplicar
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mb-3 col-md-4" key="fechaInicioServicio">
                                        <label className="form-label">Fecha Inicio Rotación</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="fechaInicioServicio"
                                            value={datosTutorPago['fechaInicioServicio']}
                                            onChange={handleChangeTutorPago}
                                            required={true}
                                        />
                                    </div>
                                    <legend className="w-auto">Patrón de turno</legend>
                                    <div className="form-group">
                                        <label>Días de turno</label><br />
                                        <div className="col-md-12 mb-3 row">
                                            {diasOrdenadosUI.map(code => {
                                                const day = daysMap.find(d => d.value === code);
                                                return (
                                                    <div key={day.value} className="col-md-1">
                                                        <label className="form-label" htmlFor={day.value}>
                                                            {day.label}
                                                        </label>
                                                        <br />
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`svc-${day.value}`}
                                                            value={day.value}
                                                            checked={serviceDays.includes(day.value)}
                                                            onChange={() => toggleServiceDay(day.value)}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>

                                    </div>
                                    <hr />
                                    <div className="form-group">
                                        <label>Tipo</label><br />
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                id="fixed"
                                                name="patternType"
                                                value="fixed"
                                                className="form-check-input"
                                                checked={patternType === 'fixed'}
                                                onChange={() => setPatternType('fixed')}
                                            />
                                            <label className="custom-control-label" htmlFor="fixed">Fijo</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                id="rotative"
                                                name="patternType"
                                                value="rotative"
                                                className="form-check-input"
                                                checked={patternType === 'rotative'}
                                                onChange={() => setPatternType('rotative')}
                                            />
                                            <label className="custom-control-label" htmlFor="rotative">Rotativo</label>
                                        </div>
                                    </div>

                                    {patternType === 'fixed' ? (
                                        <div className="form-group" id="fixed-options">
                                            <label>Periodo Fijo</label>
                                            <select
                                                className="form-control"
                                                value={fixedPeriod}
                                                onChange={e => setFixedPeriod(e.target.value)}
                                            >
                                                <option value="day">Sólo Día</option>
                                                <option value="night">Sólo Noche</option>
                                                <option value="full">Día y Noche</option>
                                            </select>
                                            <div className="row">
                                                {/* Hora inicio */}
                                                <div className="col-md-4 mb-3">
                                                    <label>Hora Inicio Turno</label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        value={patternStartTime}
                                                        onChange={e => setPatternStartTime(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                                {/* Hora fin */}
                                                <div className="col-md-4 mb-3">
                                                    <label>Hora Fin Turno</label>
                                                    <input
                                                        type="time"
                                                        className="form-control"
                                                        value={patternEndTime}
                                                        onChange={e => setPatternEndTime(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="form-group" id="rotative-options">
                                            <label>
                                                Patrón de Rotación
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-primary ml-2"
                                                    onClick={addPatternRow}
                                                >
                                                    Añadir Fase
                                                </button>
                                            </label>
                                            <div id="pattern-container">
                                                {patternRows.map((row, idx) => (
                                                    <div key={idx} className="pattern-row row g-2 mb-2 p-2 border-bottom">
                                                        <div className="col-md-3 mb-2">
                                                            <label>Tipo</label>
                                                            <select
                                                                className="form-control"
                                                                value={row.period}
                                                                onChange={e => handlePatternRowChange(idx, 'period', e.target.value)}
                                                            >
                                                                <option value="day">Día</option>
                                                                <option value="night">Noche</option>
                                                                <option value="full">Día y Noche</option>
                                                                <option value="mixto">Mixto</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2 mb-2">
                                                            <label>Cantidad de dias</label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                min="1"
                                                                placeholder="Número de días"
                                                                required
                                                                value={row.days}
                                                                onChange={e => handlePatternRowChange(idx, 'days', e.target.value)}
                                                            />
                                                        </div>
                                                        {/* Hora inicio */}
                                                        <div className="col-md-2 mb-2">
                                                            <label>Hora Inicio Turno</label>
                                                            <input
                                                                type="time"
                                                                className="form-control"
                                                                value={row.start}
                                                                onChange={e => handlePatternRowChange(idx, 'start', e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        {/* Hora fin */}
                                                        <div className="col-md-2 mb-2">
                                                            <label>Hora Fin Turno</label>
                                                            <input
                                                                type="time"
                                                                className="form-control"
                                                                value={row.end}
                                                                onChange={e => handlePatternRowChange(idx, 'end', e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-md-1 mb-2 d-flex align-items-end">
                                                            <label>Eliminar</label>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                onClick={() => removePatternRow(idx)}
                                                            >
                                                                −
                                                            </button>
                                                        </div>
                                                        {row.period === 'mixto' && (
                                                            <div className="col-12 mt-1">
                                                                <div className="d-flex flex-wrap gap-2 align-items-center bg-light px-2 py-1 rounded" style={{ borderLeft: '3px solid #0d6efd' }}>
                                                                    <span className="small fw-bold text-primary me-2"><i className="bi bi-gear-fill me-1"></i>Mixto:</span>
                                                                    {Array.from({ length: parseInt(row.days) || 0 }).map((_, dayIdx) => (
                                                                        <div key={dayIdx} className="d-flex align-items-center mb-1 mt-1">
                                                                            <span className="small text-muted me-1" style={{fontSize: '0.75rem'}}>D{dayIdx + 1}:</span>
                                                                            <select
                                                                                className="form-control form-control-sm border-primary"
                                                                                style={{ width: '100px', fontSize: '0.75rem', padding: '0.1rem 0.5rem' }}
                                                                                value={row.dailyPeriods?.[dayIdx] || 'full'}
                                                                                onChange={e => handleDailyPeriodChange(idx, dayIdx, e.target.value)}
                                                                            >
                                                                                <option value="full">Día/Noche</option>
                                                                                <option value="day">Día</option>
                                                                                <option value="night">Noche</option>
                                                                                <option value="libre">Libre</option>
                                                                            </select>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </fieldset>
                            </div>
                            {/* Datos de los Servicios del Paciente y Auxiliar */}
                            <div className="col-md-6">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Valor servicio familia</legend>
                                    <div className="row">
                                        {[
                                            { name: "valorTurnoPaciente", label: "Valor turno", required: true },
                                            { name: "valorTurnoBasePaciente", label: "Valor turno Base", required: true },
                                            { name: "valorColacionPaciente", label: "Valor colación", required: true },
                                            { name: "valorLocomocionPaciente", label: "Valor locomoción", required: true },
                                            { name: "valorOtroPaciente", label: "Valor otro", required: true },
                                        ].map((field) => (
                                            <div className="mb-3" key={field.name}>
                                                <label className="form-label">{field.label}</label>
                                                <input
                                                    type={field.type || "number"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosValoresServicios[field.name]}
                                                    onChange={handleDatosValoresServicios}
                                                    {...(field.required && { required: true })}
                                                />
                                            </div>
                                        ))}
                                        <div className="mb-3">
                                            <label className="form-label">Valor turno alternativo</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="valorTurnoAlternativoPaciente"
                                                value={datosValoresServicios.valorTurnoAlternativoPaciente}
                                                onChange={handleDatosValoresServicios}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Tipo valor alternativo</label>
                                            <select
                                                className="form-control"
                                                name="tipoValorAlternativoPaciente"
                                                value={datosValoresServicios.tipoValorAlternativoPaciente}
                                                onChange={handleDatosValoresServicios}
                                            >
                                                <option value={0}>Normal</option>
                                                <option value={1}>Fuera de santiago</option>
                                                <option value={2}>Fin de semana</option>
                                                <option value={3}>Fuera de santiago noches 50%</option>
                                            </select>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-md-6">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Valor servicio auxiliar</legend>
                                    <div className="row">
                                        {[
                                            { name: "valorTurnoAuxiliar", label: "Valor turno", required: true },
                                            { name: "valorTurnoBaseAuxiliar", label: "Valor turno Base", required: true },
                                            { name: "valorColacionAuxiliar", label: "Valor colación", required: true },
                                            { name: "valorLocomocionAuxiliar", label: "Valor locomoción", required: true },
                                            { name: "valorOtroAuxiliar", label: "Valor otro", required: true },
                                        ].map((field) => (
                                            <div className="mb-3" key={field.name}>
                                                <label className="form-label">{field.label}</label>
                                                <input
                                                    type={field.type || "number"}
                                                    className="form-control"
                                                    name={field.name}
                                                    value={datosValoresServicios[field.name]}
                                                    onChange={handleDatosValoresServicios}
                                                    {...(field.required && { required: true })}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-md-12">
                                <fieldset className="border p-3 mb-3">
                                    <legend className="w-auto">Recordatorio (opcional)</legend>
                                    <div className="mb-3">
                                        <textarea
                                            className="form-control"
                                            name="recordatorio"
                                            rows="3"
                                            placeholder="Ej: Paciente requiere confirmación especial..."
                                            value={datosValoresServicios.recordatorio || ""}
                                            onChange={handleDatosValoresServicios}
                                        />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div className="text-center mt-4">
                            <button type="submit" className="btn btn-primary">
                                Guardar
                            </button>
                        </div>
                    </form>

                </div >
            </div >
        </div >
    );
};

export default FormPacienteInicial;
